import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import avatarFase2Ct2Mp4 from "../../assets/videos/avatar-fase2-ct2.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "../StartGame.css";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "./Scenario3.css";

const MAN_STATEMENT =
	"Yo no he robado nada. Ni siquiera conozco a esa mujer.\n\n" +
	"Estaba en la plaza esperando a un amigo y, de repente, empezó a señalarme delante de todo el mundo diciendo que yo le había quitado la cartera.\n\n" +
	"Es verdad que estaba cerca, porque había bastante gente saliendo del bar, pero no he tocado su bolso ni he cogido nada.\n\n" +
	"Cuando me acusó, me puse nervioso porque todo el mundo empezó a mirarme y algunos se pusieron a grabar.\n\n" +
	"No llevo ninguna cartera que no sea mía y no tengo ningún problema en colaborar, pero no quiero que me traten como culpable sin pruebas.";

const TYPEWRITER_MS_PER_CHAR = 70;

export default function Scenario3Context2() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 1.0,
	});

	const [visibleLen, setVisibleLen] = useState(0);
	const typingComplete = visibleLen >= MAN_STATEMENT.length;

	useEffect(() => {
		const id = window.setInterval(() => {
			setVisibleLen((n) => {
				const next = n + 1;
				if (next >= MAN_STATEMENT.length) {
					window.clearInterval(id);
					return MAN_STATEMENT.length;
				}
				return next;
			});
		}, TYPEWRITER_MS_PER_CHAR);
		return () => window.clearInterval(id);
	}, []);

	const displayed = MAN_STATEMENT.slice(0, visibleLen);

	return (
		<div className="start-game-page start-game-page--welcome sc3-context1-dialogue-page">
			<div className="start-game-inner">
				<div className="start-game-grid">
					<div className="start-game-visual">
						<span className="start-game-badge">
							<span className="start-game-badge-dot" aria-hidden />
							Escenario 3 · Evolución
						</span>
						<div className="start-game-avatar-wrap sc3-context1-avatar-wrap">
							<div className="start-game-avatar-inner">
								<video
									ref={videoRef}
									autoPlay
									muted={!canPlayWithSound}
									playsInline
									preload="metadata"
									aria-label="Declaración en vídeo"
								>
									<source src={avatarFase2Ct2Mp4} type="video/mp4" />
								</video>
							</div>
						</div>
					</div>

					<div className="start-game-panel sc3-context1-dialogue-panel">
						<p className="start-game-kicker sc3-context1-kicker">Declaración</p>
						<p className="start-game-lead sc3-context1-typewriter" aria-live="polite">
							{displayed}
							{typingComplete ? null : (
								<span className="sc3-context1-caret" aria-hidden>
									▍
								</span>
							)}
						</p>
						<div className="start-game-footer sc3-context1-footer">
							<Scenario2NextCta
								navigateTo={ROUTES.SCENARIO3_QUIZ2}
								activeScenario={activeScenario}
								label="Continuar"
								canContinue={typingComplete}
								lockedTitle="Espera a que termine la declaración para continuar"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}
